{
  "secretary": {
    "navLabel": "السكرتير الذكي",
    "title": "السكرتير الذكي في {{brand}}",
    "recorder": {
      "record": "قل أمرًا واحدًا — مثلًا «احجز موعدًا لرضائي غدًا الساعة العاشرة»",
      "recording": "أستمع…",
      "stop": "إيقاف وتنفيذ",
      "discard": "تجاهل",
      "processing": "السكرتير يعمل…",
      "warn": {
        "nothing": "لم أسمع شيئًا",
        "busy": "السكرتير ما زال مشغولًا بالأمر السابق",
        "mic": {
          "denied": "لم يُمنح إذن الميكروفون",
          "unsupported": "هذا المتصفح لا يسجّل الصوت",
          "error": "لم يُفتح الميكروفون"
        }
      }
    },
    "notice": {
      "listLabel": "نتائج السكرتير الذكي",
      "heard": "سمعت: «{{text}}»",
      "dismiss": "إغلاق",
      "more": "{{count}} نتائج أخرى",
      "open": "فتح",
      "bookReady": "موعد {{name}} جاهز",
      "followUpReady": "متابعة {{name}} جاهزة",
      "slotLine": "{{day}}، الساعة {{time}}",
      "slotLineClinic": "{{day}}، الساعة {{time}} — {{clinic}}",
      "noSlot": "لم يُعثر على وقت متاح",
      "choosePatient": "أيّ «{{name}}»؟",
      "candidates": "{{count}} مرضى بهذا الاسم",
      "notFound": "«{{name}}» ليس بين مرضاك",
      "openRecord": "ملف {{name}}",
      "daySummary": "لديك اليوم {{total}} مواعيد",
      "noClinic": "ليس لديك عيادة لحجز المواعيد",
      "outOfScope": "هذا ليس من عمل السكرتير",
      "unavailable": "تعذّرت قراءة جدول اليوم",
      "unknown": "لم أفهم",
      "failed": "لم يتمكّن السكرتير من التنفيذ",
      "noCredit": "رصيد {{coin}} غير كافٍ"
    },
    "window": {
      "close": "إغلاق",
      "recordAgain": "قلها مرة أخرى",
      "heard": "سمعت",
      "openForm": "فتح نموذج حجز الموعد",
      "pickSlot": "اختر أحد هذه الأوقات؛ يُفتح نموذج الحجز معبّأً به.",
      "hourTaken": "الساعة {{time}} محجوزة؛ أقرب الأوقات المتاحة:",
      "hourFree": "الساعة {{time}} متاحة.",
      "slot": "{{day}}، الساعة {{time}}",
      "requestOnly": "أغلقت هذه العيادة الحجز المباشر؛ يُرسل الموعد كطلب لتأكيد الاستقبال.",
      "noSlotLine": "لم يُعثر على وقت متاح لـ{{name}} في هذه الفترة. يمكنك فتح النموذج واختيار يوم آخر.",
      "choosePatientLine": "لديك عدة مرضى باسم قريب من «{{name}}». أيّهم؟",
      "newPatient": "مريض جديد",
      "file": "الملف {{file}}",
      "age": "{{age}} سنة",
      "phoneTail": "الجوال …{{tail}}",
      "notFoundLine": "لم يُعثر على مريض باسم «{{name}}» بين مرضى عياداتك.",
      "closest": "أقرب الأسماء:",
      "noClinicTitle": "ليست لديك عيادة بعد",
      "noClinicLine": "لحجز المواعيد يجب أن تكون عضوًا في عيادة أو أن تنشئ عيادتك. ما زال السكرتير يفتح الملفات ويخبرك بجدول اليوم.",
      "readOnlyTitle": "انتهت اشتراكات عياداتك",
      "readOnlyLine": "لا يمكن حجز موعد في العيادة حتى تجدّد اشتراكها.",
      "goReception": "الذهاب إلى الاستقبال",
      "dayTitle": "لديك اليوم {{total}} مواعيد",
      "dayCounts": "{{completed}} منجز · {{arrived}} حاضر · {{scheduled}} في الانتظار",
      "dayRequested": "{{count}} طلبات بانتظار تأكيد العيادة",
      "dayNext": "القادم:",
      "dayNone": "لا يوجد موعد آخر اليوم.",
      "noHour": "خارج المواعيد",
      "unknownPatient": "مريض",
      "status": {
        "scheduled": "في الانتظار",
        "requested": "بانتظار تأكيد العيادة",
        "arrived": "حاضر",
        "in_visit": "في الزيارة"
      },
      "outOfScopeTitle": "هذا ليس من عمل السكرتير",
      "topic": {
        "clinical_record": "اكتب الوصفة والتشخيص والملاحظات داخل الزيارة نفسها.",
        "visit_flow": "تبدأ الزيارة وتنتهي من الاستقبال ومن الزيارة نفسها.",
        "mark_arrived": "تسجيل حضور المريض من عمل استقبال العيادة.",
        "reschedule_or_cancel": "لنقل موعد أو إلغائه افتحه في الاستقبال.",
        "money": "راجع الأمور المالية في «المحاسبة».",
        "send_message": "أرسل الرسائل إلى المرضى من «الرسائل».",
        "delete_record": "السكرتير لا يحذف شيئًا.",
        "other": "يجهّز السكرتير المواعيد والمتابعات ويفتح الملفات ويخبرك بجدول اليوم."
      },
      "unavailableLine": "تعذّرت قراءة جدول اليوم الآن. اسأل مرة أخرى بعد قليل.",
      "unknownLine": "يستطيع السكرتير تجهيز المواعيد والمتابعات وفتح ملف وإخبارك بجدول اليوم.",
      "failedLine": "قلها مرة أخرى. إن تكرّر ذلك فأنجز العمل من صفحته.",
      "noCreditLine": "اشحن رصيد {{coin}} لاستخدام السكرتير.",
      "topUp": "شحن {{coin}}",
      "charged": "خُصم {{coin}} لهذا الأمر.",
      "notCharged": "لم يُخصم {{coin}} لهذا الأمر."
    },
    "form": {
      "notice": "عبّأ السكرتير الذكي هذا النموذج مما قلته؛ راجعه قبل الحجز.",
      "reception_clinic": "العيادة: المختارة في الاستقبال.",
      "working_hours": "اختيرت العيادة حسب ساعات حضورك.",
      "earliest_free": "اختيرت العيادة التي لديها أقرب وقت متاح.",
      "newPatient": "مريض جديد؛ يُنشأ ملفه عند حجز الموعد.",
      "heardPhone": "الرقم الذي سمعته: {{phone}}",
      "booked": "تم حجز الموعد.",
      "requested": "أُرسل طلب الموعد إلى العيادة للتأكيد."
    }
  }
}
